import type { RouteObject } from "react-router-dom";
import ApplicabilityPage from "./Applicability";
import AppError from "../app-error";

export const settingsRoutes: RouteObject[] = [
  { path: "settings/applicability", Component: ApplicabilityPage, errorElement: <AppError /> },
];
